import api from './api'

class RankingService {
    // 获取todo价值日排行榜数据
    static async getWorthRankingDaily(date) {
        let url = '/usertodo/get_worth_ranking_daily/'
        if (date) {
            url += `?date=${date}`
        }
        const response = await api.get(url)
        return response.data
    }

    // 获取todo价值周排行榜数据
    static async getWorthRankingWeekly(date) {
        let url = '/usertodo/get_worth_ranking_weekly/'
        if (date) {
            url += `?date=${date}`
        }
        const response = await api.get(url)
        return response.data
    }

    // 获取todo价值月排行榜数据
    static async getWorthRankingMonthly(date) {
        let url = '/usertodo/get_worth_ranking_monthly/'
        if (date) {
            url += `?date=${date}`
        }
        const response = await api.get(url)
        return response.data
    }

    // 获取todo价值年排行榜数据
    static async getWorthRankingYearly(date) {
        let url = '/usertodo/get_worth_ranking_yearly/'
        if (date) {
            url += `?date=${date}`
        }
        const response = await api.get(url)
        return response.data
    }

    // 获取todo价值总排行榜数据
    static async getWorthRankingTotal() {
        const response = await api.get('/usertodo/get_worth_ranking_total/')
        return response.data
    }

    // 获取英语单词日排行榜数据
    static async getAbhsRankingDaily(date) {
        let url = '/userranking/getAbhsRankingDaily/'
        if (date) {
            url += `?date=${date}`
        }
        const response = await api.get(url)
        return response.data
    }

    // 获取英语单词周排行榜数据
    static async getAbhsRankingWeekly(date) {
        let url = '/userranking/getAbhsRankingWeekly/'
        if (date) {
            url += `?date=${date}`
        }
        const response = await api.get(url)
        return response.data
    }

    // 获取英语单词月排行榜数据
    static async getAbhsRankingMonthly(date) {
        let url = '/userranking/getAbhsRankingMonthly/'
        if (date) {
            url += `?date=${date}`
        }
        const response = await api.get(url)
        return response.data
    }

    // 获取英语单词年排行榜数据
    static async getAbhsRankingYearly(date) {
        let url = '/userranking/getAbhsRankingYearly/'
        if (date) {
            url += `?date=${date}`
        }
        const response = await api.get(url)
        return response.data
    }

    // 获取英语单词总排行榜数据
    static async getAbhsRankingTotal() {
        const response = await api.get('/userranking/getAbhsRankingTotal/')
        return response.data
    }

    // 获取英语单词所有单词数排行榜数据
    static async getAbhsRankingAllWords() {
        const response = await api.get('/userranking/getAbhsRankingAllWords/')
        return response.data
    }
}

export default RankingService